import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API_URL } from "../helpers";

import "./styles.css";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";

import Step1 from "./Step1";
import Step2 from "./Step2";
import Form1 from "./Form1";
import Form2 from "./Form2";
import Form3 from "./Form3";
import Form4 from "./Form4";
import Report from "./Report";
import Report2 from "./Report2";

const Charity = () => {
	const [names, setNames] = useState({
		step: 1,
		form: 0,
		signedinToken: "",
	});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const query = new URLSearchParams(useLocation().search);

	useEffect(() => {
		init();

		// eslint-disable-next-line
	}, []);

	const init = async () => {
		const url = new URL(`${API_URL}/charityInit`);
		const params = {
			code: query.get("code") || "",
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleUpdate("charityId", json.id);
				handleUpdate("charity", json.charity);
				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	return (
		<div id="full-column">
			<Hdg section="Management" />
			<>
				{alert.type ? (
					<Alert data={alert} />
				) : (
					<>
						<h3>
							<i className="fa fa-sign-in" /> &nbsp;{names.charity}
						</h3>
						<p>
							The Chair, Vice Chair or additional contact we have on file for
							your charity can gain access to the management area. Please enter
							your email address below and we will email you a one-time access
							code.
						</p>

						<p style={{ marginBottom: "15px" }}>
							Should you have any questions, please contact{" "}
							<a href="mailto:stephanie@valerotexasopen.com">
								Stephanie@ValeroTexasOpen.com
							</a>{" "}
							or at 210.345.3839.
						</p>

						{names.step === 1 && (
							<Step1 charityId={names.charityId} update={handleUpdate} />
						)}
						{names.step === 2 && (
							<Step2
								token={names.signinToken}
								email={names.email}
								update={handleUpdate}
							/>
						)}

						{names.signedinToken && (
							<>
								<h4 style={{ marginTop: "25px" }}>
									Customize your donation form using the buttons below.
								</h4>

								<div className="forms-grid">
									{[
										{
											id: 1,
											name: "Charity Mission & Fundraising Goals",
										},

										{
											id: 2,
											name: "Suggested Donation Amounts",
										},

										{
											id: 3,
											name: "Upload Photos",
										},
										{
											id: 4,
											name: "Add YouTube Video",
										},
									].map((item, index) => {
										return (
											<button
												key={index}
												type="button"
												className={
													item.id === names.form
														? "btn btn-primary"
														: "btn btn-default"
												}
												onClick={(e) => {
													handleUpdate("form", item.id);
												}}
											>
												{item.name}
											</button>
										);
									})}
								</div>

								{names.signedinToken && names.form === 1 && (
									<Form1 token={names.signedinToken} update={handleUpdate} />
								)}
								{names.signedinToken && names.form === 2 && (
									<Form2 token={names.signedinToken} update={handleUpdate} />
								)}
								{names.signedinToken && names.form === 3 && (
									<Form3 token={names.signedinToken} update={handleUpdate} />
								)}
								{names.signedinToken && names.form === 4 && (
									<Form4 token={names.signedinToken} update={handleUpdate} />
								)}

								<div className="other-grid">
									<div>
										<button>
											<span>
												<i className="fa fa-file-text fa-2x" />
												<h4>Create Donations Report</h4>
											</span>
										</button>
										<form />
									</div>

									<div>
										<Report token={names.signedinToken} />
									</div>
								</div>

								<div className="other-grid" style={{ marginTop: "15px" }}>
									<div>
										<button>
											<span>
												<i className="fa fa-users fa-2x" />
												<h4>Create Friendraising Report</h4>
											</span>
										</button>
										<form />
									</div>

									<div>
										<Report2 token={names.signedinToken} />
									</div>
								</div>
							</>
						)}
					</>
				)}
			</>
		</div>
	);
};

export default Charity;
